/**
 * @description function that identifies the correct orgId to pass to the redirect Url.
 * Prioritize the org id in the url param
 * if no org id in the url and the isDmp flag is true, choose the 1st dmp org that
 * the chosen namespace can log into.
 * otherwise choose the org of thechosen namespace.
 * @param {string} orgIdUrlParam - This takes priority and should be the org id in the url param.
 * @param {object} namespace - choose the org of the chosen namespace as a last resort.
 * @param {string} isDmp - choose the 1st dmp org that the chosen namespace can log into if no url param.
 * @returns string
 */
export const getOrgIdForRedirect = (
  orgIdUrlParam: string | null,
  namespace: Api.Response['determineLoginCandidateNamespaces'][0],
  isDmp?: boolean,
): string => {
  let orgId: string | number | undefined =
    namespace.org?.id ?? namespace.identityProvider?.org?.id;

  if (isDmp) {
    // Grab the namespace within the matchedIdentity that has dmp
    const dmpUser = namespace.matchedIdentity?.users?.find((user) => {
      return user.org?.orgAwareConfig?.isDmpOrg;
    });

    orgId = dmpUser?.org?.id;
  }

  orgId = orgIdUrlParam ?? orgId;

  return String(orgId ?? '');
};
